import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboTipoEscolaComponent } from './combo-tipo-escola.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboTipoEscolaComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboTipoEscolaComponent]
})
export class ComboTipoEscolaModule { }
